<template>
  <input
    ref="inputText"
    :value="value"
    :type="type"
    :disabled="disabled"
    :placeholder="placeholder"
    :readonly="readonly"
    :class="{...classes, 'is-invalid': invalid}"
    class="form-control"
    autocomplete="off"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
  >
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

const props = withDefaults(defineProps<{
  value?: PropType<string | number> | null;
  type?: string;
  classes?: any;
  disabled?: boolean;
  readonly?: boolean;
  placeholder?: string;
  invalid?: boolean;
  selectOnFocus?: boolean;
}>(), {
  value: null,
  disabled: false,
  type: 'text',
  readonly: false,
  invalid: false,
  selectOnFocus: false,
  placeholder: '',
  classes: () => ({}),
})

const emit = defineEmits<{
  (event: 'input', value: string | number | null): void
  (event: 'blur', value: string): void
}>()

const onInput = (e: any) => {
  const value = !e.target?.value ? null : e.target.value

  emit('input', value)
}

const onBlur = (e: any) => {
  emit('blur', !e.target?.value ? null : e.target.value)
}

const onFocus = (event: FocusEvent | KeyboardEvent) => {
  if (props.selectOnFocus && event.target instanceof HTMLInputElement) event.target.select()
}
</script>
